import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiLockPasswordLine } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class HowToResetYourPasswordHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "How to reset your password",
      description:
        "At the end of this guide you will be able to:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "reset your password and regain access to your account",
    },
    {
      title: "Go to the sign-in page",
      description:
        "Navigate to the <a href='/sign-in'>sign-in page</a>. You can reach it by clicking the <b>Sign In</b> button in the navigation bar at the top of any page.",
    },
    {
      title: "Click the reset link",
      description:
        "Below the sign-in form, click the link that reads <b>Forgot your password? Request a password reset email</b>. This will take you to the password reset request page.",
    },
    {
      title: "Enter your email address",
      description:
        "Enter the email address associated with your account and click <b>Send reset email</b>. If an account exists for that address, a reset link will be sent to your inbox.",
    },
    {
      title: "Check your email",
      description:
        "Open the email from The Worship Bible. It will contain a password reset link. If you cannot find it, check your spam or junk folder. The link is valid for a limited time, so use it promptly.",
    },
    {
      title: "Follow the link and create a new password",
      description:
        "Click the link in the email. You will be taken to a page where you can enter and confirm your new password. Your password must be at least 8 characters long. Click <b>Reset password</b> to save it.",
    },
    {
      title: "What's next",
      description:
        "Your password has been reset. You can now sign in with your new credentials." +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/how-to-sign-in'>How to sign in</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> View our other <a href='/help'>help articles</a> for more guidance.",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/how-to-reset-your-password"
          title="How to reset your password | Help | The Worship Bible"
          description="Step-by-step guide to resetting your password if you have forgotten it."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiLockPasswordLine color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">How to reset your password</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default HowToResetYourPasswordHelp;
